<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			
			<FormItem prop="trackName" :label="this.$t('Station')" :label-width="100">
				<Select clearable :placeholder="this.$t('EquipmentType')" style="width: 200px;" v-model="formInline.deviceType">
				
				</Select>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')">{{ $t('Common.Search') }}</Button>
			</FormItem>
		</Form>
		<Card style="margin-bottom: 20px;box-shadow: 2px 2px 4px #a7a7a7;width: 100%;background-color: white;">
			<Row>
				<Col span="5">
				<Tag color="success" type="dot">{{ $t('StationMonitoring.TotalQty') }}:{{Summary.Total}}</Tag>
				</Col>
				<Col span="5">
				<Tag color="primary" type="dot">{{ $t('StationMonitoring.ChargingQty') }}:{{Summary.Charging}}</Tag>
				</Col>
				<Col span="4">
				<Tag color="warning" type="dot">{{ $t('StationMonitoring.StandbyQty') }}:{{Summary.Standby}}</Tag>
				</Col>
				<Col span="5">
				<Tag color="default" type="dot">{{ $t('StationMonitoring.OfflineQty') }}:{{Summary.Offline}}</Tag>
				</Col>
				<Col span="5">
				<Tag color="error" type="dot">{{ $t('StationMonitoring.AlarmingQty') }}:{{Summary.Alarming}}</Tag>
				</Col>
			</Row>
		</Card>
		<Table :row-class-name="rowClassName" :columns="columns1" :data="data1" :height="tableHeight" ref="table">
		</Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getEqumentStatusUrl" @listData='getDeviceData'></MyPage>
	</div>
</template>

<script>
	import echarts1 from "../../../js/echarts_hot.js";
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import webapi from '../../../webapi.js';

	export default {
		data() {
			
			return {
				getEqumentStatusUrl: webapi.base_api_url + '/Operations/GetEqumentStatus',
				loadingStatus: false,
				//
				params: "", //
				
				tableHeight: "650",
				
				Summary: {
					Total: 0,
					Charging: 0,
					Standby: 0,
					Offline: 0,
					Alarming: 0,
				},
				
				pageTotal: 10,
				pageSize: 10,
				opts: [10, 20, 30, 40],
				chectedPage: 1,
				BreadcrumbList: [this.$t('stationMonitoring'), '>>', this.$t('equipmentMonitoring')],
				formInline: {
					deviceNum: '',
					deviceStat: '',
					deviceType: ''
				},
				//Table Title Data
				columns1: [{
						title: this.$t('EquipmentNo'),
						key: 'EquipmentNo',
					}, {
						title: this.$t('EquipmentName') ,
						key: 'EquipmentName',
					},
					{
						title: this.$t('ConnectorNo'),
						key: 'ConnectorNo'
					},
					{
						title: this.$t('ConnectorName') ,
						key: 'ConnectorName'
					},
					{
						title: this.$t('EquipmentType') ,
						key: 'EquipmentType'
					},
					{
						title: this.$t('ConnectorType'),
						key: 'ConnectorType'
					},
					{
						title: this.$t('WorkStatus'),
						key: 'WorkStatus'
					},
					{
						title: this.$t('AlarmCode'),
						key: 'MaxAlarmCode'
					},
					{
						title: this.$t('stationMonitoring.ConnectionStatus'),
						key: 'CarCoupleStatus'
					},
					{
						title: this.$t('stationMonitoring.RatedPower'),
						key: 'RatedPower'
					},
					{
						title: this.$t('Station'),
						key: 'StationName'
					}, {
						title: this.$t('Common.Actions'),
						key: 'action',
						width: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("update", params.row.id)
										}
									}
								}, this.$t('Common.Edit')),
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("install", params.row.id)
										}
									}
								}, this.$t('Install'))
							]);
						}
					}
				],
				data1: []
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 300;
			window.addEventListener('resize', this.getTableHeight)
			_this.handleSubmit();
			//_this.GetUserStations();
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					deviceType: ''
				}
				return param
			},
		},
		methods: {
			handleSubmit: function() {
				const _this = this;
				let parms = {
					id: "params"
				}
				_this.$axios.post(webapi.base_api_url + "/Operations/GetEqumentStatus", parms, {
				}).then(res => {
					console.log("res")
					console.log(res.data)
					if (res.data.Code == 0) {
						_this.data1 = res.data.Data.Detail;
						_this.Summary = res.data.Data.Summary;
					}
				})
			},
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.Detail
				_this.Summary = data.Data.Summary;
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 300;
			},
			GetUserStations: function() {
				const _this = this;
				let parms = {
					id: "params"
				}
				_this.$axios.post(webapi.base_api_url + "/Home/GetUserStations", parms, {
				}).then(res => {
					console.log("station list")
					console.log(res.data)
					if (res.data.Code == 0) {
						_this.data1 = res.data.Data.Detail;
						_this.Summary = res.data.Data.Summary;
					}
				})
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
